import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Item } from "../../items/item.entity";
import { Taxes } from "../../taxes/taxes.entity";
import { Vendors } from "../../vendors/vendors.entity";

@Entity('vendor_price_list')
export class VendorsPriceList{

    @PrimaryGeneratedColumn('increment',{
        name:'vendor_price_list_id'
    })
    vendorPriceListId:number;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "unit_price",
        default: 0
    })
    unitPrice: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "discount_percentage",
        default: 0
    })
    discountPercentage: number;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "discount_price",
        default: 0
    })
    discountPrice: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "actual_price",
        default: 0
    })
    actualPrice: number;

    @Column("varchar", {
        nullable: false,
        name: "sku_code",
        length:50
    })
    skuCode: string | null;

    

    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
        })
      isActive:boolean;
    
      @CreateDateColumn({
        name: "created_at",
        type:"datetime"
      })
      createdAt: Date;
    
      @Column("varchar", {
          nullable: false,
          name: "created_user",
          length:50
      })
      createdUser: string | null;
    
    
      @UpdateDateColumn({
          name: "updated_at",
          type:'datetime'
      })
      updatedAt: Date;
    
      @Column("varchar", {
          nullable: true,
          name: "updated_user",
          length:50
      })
      updatedUser: string | null;
    
      @VersionColumn({
          default:1,
          name: "version_flag"
      })
      versionFlag: number;

      @ManyToOne(type => Vendors, vendor => vendor.vendorsPriceList, { nullable: false, })
      @JoinColumn({ name: 'vendor_id' })
      vendors: Vendors;

      @ManyToOne(type => Item, items => items.vendorsPriceList, { nullable: false, })
      @JoinColumn({ name: 'item_id' })
      items: Item;

      @ManyToOne(type => Taxes, tax => tax.vendorsPriceList, { nullable: false, })
      @JoinColumn({ name: 'tax_id' })
      taxes: Taxes;
}